import { render, staticRenderFns } from "./VisitSummaryMedication.vue?vue&type=template&id=437dcbbb&scoped=true&lang=pug&"
import script from "./VisitSummaryMedication.vue?vue&type=script&lang=js&"
export * from "./VisitSummaryMedication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437dcbbb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VHover,VIcon})
